import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Box } from '@mui/material';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import Dashboard from './pages/Dashboard';
import Campaigns from './pages/Campaigns';
import Leads from './pages/Leads';
import Content from './pages/Content';
import Analytics from './pages/Analytics';
import Settings from './pages/Settings';
import Login from './pages/Login';
import ICPs from './pages/ICPs';
import Posts from './pages/Posts';
import Inbox from './pages/Inbox';
import Integrations from './pages/Integrations';
import Workflows from './pages/Workflows';
import Performance from './pages/Performance';
import Admin from './pages/Admin';
import Approvals from './pages/Approvals';

function App() {
  // Check if user is authenticated from Redux store
  const isAuthenticated = useSelector((state: any) => state.auth.isAuthenticated);

  // If not authenticated, show login page
  // Using Routes to ensure useNavigate works properly in Login component
  if (!isAuthenticated) {
    return <Login />;
  }

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/campaigns" element={<Campaigns />} />
        <Route path="/workflows" element={<Workflows />} />
        <Route path="/performance" element={<Performance />} />
        <Route path="/leads" element={<Leads />} />
        <Route path="/icps" element={<ICPs />} />
        <Route path="/content" element={<Content />} />
        <Route path="/posts" element={<Posts />} />
        <Route path="/inbox" element={<Inbox />} />
        <Route path="/analytics" element={<Analytics />} />
        <Route path="/integrations" element={<Integrations />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/approvals" element={<Approvals />} />
        <Route 
          path="/admin" 
          element={
            <ProtectedRoute requiredRole="super_admin">
              <Admin />
            </ProtectedRoute>
          } 
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
}

export default App;
